/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Lib_Deck_Phase_LockedInputs */



/**
* | output |
* | --- |
* | "Locked" |
*
* @param {Tournaments_Lib_Deck_Phase_LockedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const tournaments_lib_deck_phase_locked = /** @type {((inputs?: Tournaments_Lib_Deck_Phase_LockedInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Lib_Deck_Phase_LockedInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Gesperrt")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Verrouillé")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("已锁定")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("已鎖定")
	if (locale === "ko") return /** @type {LocalizedString} */ ("잠김")
	return /** @type {LocalizedString} */ ("Locked")
});